import { render, staticRenderFns } from "./bankAdd.vue?vue&type=template&id=634c13a8&scoped=true"
import script from "./bankAdd.vue?vue&type=script&lang=js"
export * from "./bankAdd.vue?vue&type=script&lang=js"
import style0 from "./bankAdd.vue?vue&type=style&index=0&id=634c13a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634c13a8",
  null
  
)

export default component.exports